<template>
	<!-- 页面表格组件 -->
	<div class="gametype_table_mainbox">
		<div class="gametype_table_bg">
			<!-- 顶部导航栏 -->
			<ul class="gametype_table_nav cf">
				<li>
					<a :class="typeSwitch ? 'gametype_table_select' : 'gametype_table_unselect'" @click="typeSwitch = true"
						>我的投注</a
					>
				</li>
				<li v-if="indexs !== '5' && indexs !== '7'">
					<a :class="!typeSwitch ? 'gametype_table_select' : 'gametype_table_unselect'" @click="typeSwitch = false"
						>我的追号</a
					>
				</li>
				<li class="gametype_getmore_box"><a class="gametype_getmore" @click="SwitchOther">查询更多记录</a></li>
			</ul>
			<!-- 表格 -->
			<div class="recordtable_bg_box">
				<div class="gametype_table_main" v-if="typeSwitch == true" :key="1">
					<el-table
						height="400"
						empty-text="暂无投注记录"
						:data="tablist"
						:cell-class-name="setBetClass"
						header-row-class-name="el_table_head"
						border
					>
						<el-table-column label="彩种" prop="LgName" width="120"></el-table-column>
						<el-table-column label="期号" prop="Lssue" width="120"></el-table-column>
						<el-table-column label="玩法" prop="LpName" width="106"></el-table-column>
						<el-table-column label="下注时间" prop="BetTime" width="170"></el-table-column>
						<el-table-column label="投注金额" prop="BetMoney"></el-table-column>
						<el-table-column label="中奖金额" prop="WinBonus"></el-table-column>
						<el-table-column label="状态" width="86" prop="StatusText">
							<template slot-scope="scope">
								<span class="unpaidState" v-if="scope.row.StatusText === '未开奖'">{{ scope.row.StatusText }}</span>
								<span class="chedan" v-if="scope.row.StatusText === '已撤单'">{{ scope.row.StatusText }}</span>
								<span style="color: #d11042" v-if="scope.row.StatusText === '已中奖'">{{ scope.row.StatusText }}</span>
								<span class="cancelState" style="color: #448a1f" v-if="scope.row.StatusText === '未中奖'">{{
									scope.row.StatusText
								}}</span>
							</template>
						</el-table-column>
						<el-table-column label="亏盈" prop="KuiYing">
							<template slot-scope="scope">
								<div v-if="scope.row.Status == 4 || scope.row.Status == 3">{{ scope.row.KuiYing }}</div>
								<div v-else>0</div>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click.native.prevent="Viewdetails(scope.$index, tablist)" type="text" size="small"
									>查看详情
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="gametype_table_main" v-else :key="2">
					<el-table
						height="400"
						empty-text="暂无追号记录"
						:data="tracklist"
						:cell-class-name="setTrackClass"
						header-row-class-name="el_table_head"
						border
					>
						<el-table-column label="起始期号" prop="BetTime"></el-table-column>
						<el-table-column label="已追/总（期数）" prop="OpenD"></el-table-column>
						<el-table-column label="总金额" prop="BetMoney"></el-table-column>
						<el-table-column label="状态" prop="StatusText">
							<template slot-scope="scope">
								<span class="cancelState" v-if="scope.row.StatusText === '已撤销'">{{ scope.row.StatusText }}</span>
								<span class="payState" v-if="scope.row.StatusText === '进行中'">{{ scope.row.StatusText }}</span>
								<span v-if="scope.row.StatusText === '已完成'">{{ scope.row.StatusText }}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="tem">
								<el-button type="text" size="small" @click.native.prevent="zhDetails(tem.$index, tracklist)"
									>查看详情
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		tablist: {
			type: Array,
			require: true,
		},
		tracklist: {
			type: Array,
			require: true,
		},
		indexs: {
			type: String,
			require: true,
		},
	},
	data() {
		return {
			typeSwitch: true, //切换显示卡
			tableData: [], //表单数据
		};
	},
	methods: {
		SwitchOther() {
			this.$router.push({
				name: "UserCenter",
				query: {
					name: this.typeSwitch ? "tzjl" : "zhjl",
					value: this.typeSwitch ? "tzjl" : "zhjl",
				},
			});
		},
		//查看详情数据
		Viewdetails(index, rows) {
			this.$emit("setinfo", rows[index], 1);
		},
		// 追号
		zhDetails(index, rows) {
			this.$emit("setinfo", rows[index], 2);
		},
		//设置投注数字样式
		setBetClass({ columnIndex }) {
			if (columnIndex === 1 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 7) {
				return "num";
			}
		},
		//设置追号数字样式
		setTrackClass({ columnIndex }) {
			if (columnIndex <= 3) return "num";
		},
	},
};
</script>

<style>
.gametype_table_main .chedan {
	color: #aaaaaa;
}

.gametype_table_main .unpaidState {
	color: #777777;
}

.gametype_table_main .cancelState {
	color: #008573;
}

.gametype_table_main .payState {
	color: #d86556;
}

.gametype_table_mainbox {
	overflow: hidden;
	margin-top: 30px;
	padding: 23px 20px 20px;
	border-radius: 12px;
	box-shadow: 0px 3px 9px 0 rgba(0, 0, 0, 0.15);
	background-color: #fefdfd;
}

.gametype_table_nav {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	padding: 0;
	overflow: hidden;
}

.gametype_table_nav li a {
	position: relative;
	display: block;
	margin-right: 2px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	font-family: PingFangSC;
	font-size: 15px;
	width: 120px;
	height: 36px;
	line-height: 36px;
	font-weight: normal;
}

.gametype_table_nav li a:before {
	content: "";
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 3px;
	height: 14px;
	border-radius: 3px;
	background-color: transparent;
}

.gametype_table_nav li a.gametype_table_select {
	/* background-image: linear-gradient(to top, #50b3f9, #1483d1, #50b3f9); */
	background-color: #6455fe;
}

.gametype_table_nav li a.gametype_table_unselect {
	box-shadow: inset 0.8px 2.9px 6px 0 #fff;
	/* background-image: linear-gradient(to top, #eee, #ddd, #f1f1f1); */
	background-color: #fff;
	border: solid 1px #dedede;
	color: #888;
}

.el-button--text {
	font-family: PingFangSC;
	font-size: 13px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #0e78c7;
}
.el-button--text:hover {
	color: #0e78c7;
}

.gametype_table_nav .gametype_getmore_box {
	position: absolute;
	left: auto;
	right: 24px;
	border-radius: 3px;
	box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.25);
	background-color: #6455fe;
}

.gametype_table_nav .gametype_getmore_box a {
	color: #fff;
	font-family: "PingFangSC-Regular";
	font-size: 13px;
}

.gametype_table_nav .gametype_getmore_box .gametype_getmore:after {
	content: "\E6E0";
	position: absolute;
	font-family: element-icons !important;
}

.gametype_table_main {
	overflow: hidden;
}

.gametype_table_main .el_table_head > th {
	height: 40px !important;
	padding: 0 !important;
	background-color: #6455fe !important;
}

.gametype_table_main .el-table td {
	padding: 0 !important;
	font-size: 13px;
}

.gametype_table_main .el-table td,
.el-table th.is-leaf {
	border-bottom: 1px solid #e3e3e4;
}

.gametype_table_main .el-table::before {
	height: 0;
}

.gametype_table_main .el-table tbody tr:nth-child(odd) {
	background-color: #f5f5f5;
}
.gametype_table_main .el-table tbody tr:nth-child(even) {
	background-color: #e8eaeb;
}

.gametype_table_main .el-table th > .cell {
	color: #fff;
	font-weight: normal;
	text-align: center;
	font-size: 13px;
}

.gametype_table_main .el-table__empty-block {
	background: url(../../static/img/no_record.png) no-repeat center 80px;
}

.gametype_table_main .el-table__empty-block span {
	margin-top: 40px;
}

.gametype_table_main .user_no_record {
	width: 100%;
}

.gametype_table_main .cell {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/Tablelist.vue